// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"a3dad9f3","316":"e318fde8"}[chunkId] + ".js";
};